import { PdsWidget } from '../../pds-widget';
import { pdsValidation } from '../../pds-validation';
import {GridWidget} from '../../models/grid-widget/grid-widget';
import { pdsLogger } from '../../pds-logger';
import { serviceInstances } from '../../services/service-instances';

let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('gridWidget'), 'pds-grid-widget-pagination-control.ts');

export class PdsGridWidgetPaginationControl extends PdsWidget {
  is = 'pds-grid-widget-pagination-control';
  name: string;

  dataGridWidgetId: string;
  gridWidget: GridWidget | undefined;

  properties = {
    dataGridWidgetId: {
      type: String,
      value: null,
      observer: 'gridWidgetChange'
    }
  };

  attached(): void {
    log('attached called');
    super.attached();
    let paginationContent: HTMLElement | null = this.querySelector('.pds-grid-widget-pagination-control-content');
    if (paginationContent != null) {
      paginationContent.addEventListener('input', (event: Event) => {
        (event as any).skipDirtyStateHandling = true;
      });
      paginationContent.addEventListener('change', (event: Event) => {
        (event as any).skipDirtyStateHandling = true;
      });
      paginationContent.addEventListener('modelValueChange', (event: Event) => {
        let value = Number.parseInt((event as any).target.value);
        this.rangeChange(value);
      });
    }
  }

  gridWidgetChange(): void {
    log('gridWidgetChange called');
    if (this.dataGridWidgetId != null) {
      this.subscriptions.push(serviceInstances.getGridWidgetService().getGridWidget(this.dataGridWidgetId).subscribe((gridWidget: GridWidget | undefined) => {
        this.gridWidget = gridWidget;
        if (this.gridWidget != null && this.gridWidget.paginationControl != null) {
          this.watch('gridWidget.paginationControl.pageNumber');
          this.watch('gridWidget.paginationControl.nextPageNumber');
          this.watch('gridWidget.paginationControl.numberOfPages');
          this.watch('gridWidget.paginationControl.firstInListNumber');
          this.watch('gridWidget.paginationControl.numberOfRowsInPage');
        }
      }));
    }
  }

  isShowPaginatorControl(): boolean {
    return this.gridWidget != null && this.gridWidget.paginationControl != null && this.gridWidget.paginationControl.numberOfPages > 1;
  }

  isShowPaginatorLegend(): boolean {
    return this.gridWidget != null && this.gridWidget.filterConstraint !== 'no-filters' && this.gridWidget.paginationControl != null && this.gridWidget.paginationControl.numberOfRowsInPage > 0;
  }

  buildPaginationLegend(): string {
    if (this.gridWidget == null) {
      return '';
    }

    return `${this.gridWidget.paginationControl.firstInListNumber} - ${this.gridWidget.paginationControl.firstInListNumber + this.gridWidget.paginationControl.numberOfRowsInPage - 1}`;
  }

  isSelectedPageFirstPage(gpNum?: number): boolean {
    return this.gridWidget != null && this.gridWidget.paginationControl.pageNumber === 1;
  }

  isSelectedPageLastPage(): boolean {
    return this.gridWidget != null && this.gridWidget.paginationControl.pageNumber === this.gridWidget.paginationControl.numberOfPages;
  }

  rangeChange(nextPageNumber: number | null): void {
    log('rangeChange called');
    if (this.gridWidget != null && nextPageNumber != null) {
      this.gridWidget.paginationControl.nextPageNumber = nextPageNumber;
      this.gridWidget.executeTaskChain('paginate');
    }
  }

  handlePreviousPageTap(): void {
    log('handlePreviousPageTap called');
    if (this.gridWidget == null) {
      return;
    }

    this.gridWidget.paginationControl.previousPage();
    let sliderElement = this.querySelector('pds-numbered-slider');
    if (sliderElement != null) {
      sliderElement.value = this.gridWidget.paginationControl.nextPageNumber;
    }

    this.gridWidget.executeTaskChain('paginate');
  }

  handleNextPageTap(): void {
    log('handleNextPageTap called');
    if (this.gridWidget == null) {
      return;
    }

    this.gridWidget.paginationControl.nextPage();
    let sliderElement = this.querySelector('pds-numbered-slider');
    if (sliderElement != null) {
      sliderElement.value = this.gridWidget.paginationControl.nextPageNumber;
    }

    this.gridWidget.executeTaskChain('paginate');
  }

  detached(): void {
    log('detached called');
    super.detached();
    this.cancelSubscriptions();
  }
}
